module.exports = __webpack_public_path__ + "static/media/optus-yes.9826128b.png";